'use client';

import Link from 'next/link';
import React from 'react';

import {Button} from '@/components/ui/button';

interface AboutPaymentOptionModalProps {
    paymentType?: string;
    onClose?: () => void;
    modalId?: string;
}

export const AboutPaymentOptionModal: React.FC<AboutPaymentOptionModalProps> = ({
                                                                                    onClose,
                                                                                }) => {
    return (
        <div className="p-0 font-sans">
            {/* Header */}
            <div className="h-[190px] bg-gray-200"/>

            {/* Content */}
            <div className="p-6">
                <h2 className="text-center text-2xl font-bold leading-[31.20px] text-neutral-900">
                    Buy Now. Pay later
                </h2>
                <p className="mb-3 pt-2 text-base font-medium leading-normal text-neutral-700">
                    With this payment option, you can purchase items in installments
                    using the credit you qualify for. This way, you can buy the items
                    you need without having to pay the full amount upfront.
                </p>

                <div className="mt-4 text-sm font-medium leading-normal text-neutral-500">
                    Conditions for using Buy now. Pay later
                </div>

                <div className="space-y-2 rounded bg-[#EFEBF9] p-3">
                    <div>
                        <span className="text-sm font-medium leading-normal text-neutral-700">
                            You must have qualify for credit.{' '}
                        </span>
                        <Link
                            href="/help"
                            className="text-sm font-medium leading-normal text-violet-800 underline"
                            onClick={onClose}
                        >
                            Get credit
                        </Link>
                    </div>
                    <div className="text-sm font-medium leading-normal text-neutral-900">
                        You will need to make an upfront payment.
                    </div>
                    <div className="self-stretch text-sm font-medium leading-normal text-neutral-700">
                        Items can be picked up or delivered when upfront payment has been
                        made.
                    </div>
                </div>

                <Button
                    type="button"
                    onClick={onClose}
                    className="mt-6 w-full rounded-full bg-motitoBlue text-base font-normal leading-normal text-white"
                >
                    Okay
                </Button>
            </div>
        </div>
    );
};

AboutPaymentOptionModal.displayName = 'AboutPaymentOptionModal';

export default AboutPaymentOptionModal;
